import React from 'react'

import AttachmentThumbnail from "../blocks/thumbnail/thumbnail"
import AttachmentButtonDownload from "../blocks/buttons/download"
import AttachmentButtonOpenNewWindow from "../blocks/buttons/open-new-window"
import AttachmentButtonPreview from "../blocks/buttons/preview"
import Attachment from "../../../../model2/attachment/attachment"
import {AttachFileMode} from "../../const"
import AttachmentButtonRemove from "../blocks/buttons/remove"

type Props = {
    attachment        : Attachment
    mode              : AttachFileMode
    onPreview?        : callback
    onRemove?         : callback
    onAddToMessage?   : callback
    showRemoveButton? : boolean
}

// const debug = "AttachmentViewWithPreview"
const debug = false

export default function AttachmentViewWithPreview(props: Props) {

    debug && console.log(debug, "render", props)

    const {attachment} = props

    const onClick = (e: React.SyntheticEvent) => {
        e.stopPropagation()

        if (props.mode==='edit') return

        if (props.onPreview) {
            props.onPreview(props.attachment);
        }
    }

    const onRemoveClick = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        if (props.onRemove) props.onRemove(props.attachment)
    }

    const onAddToMessageClick = () => {
        if (props.onAddToMessage) props.onAddToMessage(attachment)
    }

    const canAddToMessage   = !attachment.inMessageRTF && props.onAddToMessage
    const showViewAndEdit   = props.mode === AttachFileMode.VIEW_AND_EDIT || props.mode === AttachFileMode.VIEW
    const showEditOnly      = props.mode === AttachFileMode.EDIT

    return (
        <div className="ui5-attachment-with-preview" onClick={onClick}>
            <div className="preview">
                <AttachmentThumbnail size={160} attachment={attachment}/>
            </div>
            <div className="description">
                <div className="ui5-txt-less-important-small m-l-10">
                    {attachment.name}
                </div>
            </div>

            {showViewAndEdit &&
                <div className="overlay-details">
                    <div className="file-name ui5-txt-less-important-small m-l-10 m-t-15">
                        {attachment.name}
                    </div>
                    <div className="file-size ui5-txt-not-important-tiny m-l-10 ">
                        {attachment.fileSizeFormatted}
                    </div>

                    <div className="attachment-preview-actions">
                        <div className="attachment-buttons-block">
                            <AttachmentButtonDownload attachment={attachment}/>
                            <div className="buttons-separator"/>
                            <AttachmentButtonOpenNewWindow attachment = {attachment}/>
                            <div className="buttons-separator"/>
                            <AttachmentButtonPreview attachment     = {attachment}
                                                     onPreviewClick = {props.onPreview} />

                            {props.mode === AttachFileMode.VIEW_AND_EDIT &&
                                <>
                                    <div className="buttons-separator"/>
                                    <AttachmentButtonRemove onClick={onRemoveClick}/>
                                </>}
                        </div>
                    </div>
                </div>}

            {showEditOnly &&
                <div className="overlay-details">
                    {!canAddToMessage &&
                        <>
                            <div className="file-name ui5-txt-less-important-small m-l-10 m-t-15">
                                {attachment.name}
                            </div>
                            <div className="file-size ui5-txt-not-important-tiny m-l-10 ">
                                {attachment.fileSizeFormatted}
                            </div>
                        </>}

                    {canAddToMessage &&
                        <div className = "ui5-link-tiny m-t-50 w-100-percent t-a-center"
                             onClick   = {onAddToMessageClick}>
                            Insert in message
                        </div>}

                    <div className="attachment-preview-actions">
                        <div className="flex-row-center-center h-36">
                            <AttachmentButtonRemove onClick={onRemoveClick}/>
                        </div>

                        {/*<div className="attachment-buttons-block">*/}
                        {/*</div>*/}
                    </div>
                </div>}
        </div>
    )
}
